import {AbstractApi} from '../abstract-api';
import {LawyerEndpoint} from './endpoint/lawyer-endpoint';
import {PublicationEndpoint} from './endpoint/publication-endpoint';
import {NewsEndpoint} from './endpoint/news-endpoint';
import {ExpertiseEndpoint} from './endpoint/expertise-endpoint';
import {EventEndpoint} from './endpoint/event-endpoint';

/**
 * Manages the data API.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class DataApi extends AbstractApi {
  private static _instance: DataApi | null = null;
  private readonly _eventEndpoint: EventEndpoint;
  private readonly _expertiseEndpoint: ExpertiseEndpoint;
  private readonly _lawyerEndpoint: LawyerEndpoint;
  private readonly _newsEndpoint: NewsEndpoint;
  private readonly _publicationEndpoint: PublicationEndpoint;

  private constructor() {
    super();
    this._eventEndpoint = new EventEndpoint(this);
    this._expertiseEndpoint = new ExpertiseEndpoint(this);
    this._lawyerEndpoint = new LawyerEndpoint(this);
    this._newsEndpoint = new NewsEndpoint(this);
    this._publicationEndpoint = new PublicationEndpoint(this);
  }

  /**
   * Gets the singleton instance.
   */
  public static get instance(): DataApi {
    if (DataApi._instance === null) {
      DataApi._instance = new DataApi();
    }
    return DataApi._instance;
  }

  public get eventEndpoint(): EventEndpoint {
    return this._eventEndpoint;
  }

  public get expertiseEndpoint(): ExpertiseEndpoint {
    return this._expertiseEndpoint;
  }

  public get lawyerEndpoint(): LawyerEndpoint {
    return this._lawyerEndpoint;
  }

  public get newsEndpoint(): NewsEndpoint {
    return this._newsEndpoint;
  }

  public get publicationEndpoint(): PublicationEndpoint {
    return this._publicationEndpoint;
  }
}
